import React, { useCallback, useState } from "react";
import clsx from "clsx";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import Toggle from "components/Toggle/Toggle";
import TabPanel from "components/TabPanel/TabPanel";
import VideoPlayer from "../VideoPlayer/VideoPlayer";
import WorkoutAnalysisForm from "../WorkoutAnalysisForm";
import WorkoutAnalysisResults from "../WorkoutAnalysisResults";
import { EVideoListTab } from "../../helpers";
import useStyles from "./styles";

interface IProps {
  selectedVideo: racehorse360.ITrackOpticsVideo;
  activeTab: EVideoListTab;
  onUpdateVideoList: () => void;
  className?: string;
}

const VideoDetails = (props: IProps) => {
  const { selectedVideo, activeTab, onUpdateVideoList, className } = props;

  const classes = useStyles();

  const [isToggleActive, setIsToggleActive] = useState(true);

  const videoType = isToggleActive
    ? racehorse360.TrackOpticsVideoType.TRACK_OPTICS_VIDEO_TYPE_DETECTIONS
    : racehorse360.TrackOpticsVideoType.TRACK_OPTICS_VIDEO_TYPE_STANDARD;

  const handleSwitchToggle = useCallback(() => {
    setIsToggleActive(!isToggleActive);
  }, [isToggleActive]);

  return (
    <div className={clsx(className, classes.videoDetails)}>
      <div className={classes.contentWrapper}>
        <div className={classes.videoPlayerContainer}>
          <VideoPlayer
            trackOpticsVideoId={selectedVideo?.id}
            videoType={videoType}
          />
          <Toggle
            className={classes.toggleWrapper}
            title={"Show AI Video Overlay"}
            checked={isToggleActive}
            onSwitchToggle={handleSwitchToggle}
          />
        </div>

        <div className={classes.workoutAnalysisContainer}>
          <div className={classes.workoutAnalysisHeader}>Workouts Analysis</div>
          <TabPanel value={activeTab} index={EVideoListTab.WORKOUTS}>
            <WorkoutAnalysisForm
              trackOpticsVideo={selectedVideo}
              updateVideoList={onUpdateVideoList}
            />
          </TabPanel>
          <TabPanel value={activeTab} index={EVideoListTab.REVIEWED}>
            <WorkoutAnalysisResults
              selectedTrackOpticsVideoId={selectedVideo?.id}
            />
          </TabPanel>
        </div>
      </div>
    </div>
  );
};

export default React.memo(VideoDetails);
